import { render } from "./MooSheetHead.vue?vue&type=template&id=67bc415a&scoped=true"
import script from "./MooSheetHead.vue?vue&type=script&lang=js"
export * from "./MooSheetHead.vue?vue&type=script&lang=js"

import "./MooSheetHead.vue?vue&type=style&index=0&id=67bc415a&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bc415a"]])

export default __exports__